import { ThemeProps } from 'src/hook/useUser'
import styled from 'styled-components'

export const Wrapper = styled.div`
  transition: background ease-in-out 0.2s;

  &:hover {
    background-color: var(--gray-100);
  }
`

Wrapper.displayName = 'Wrapper'

export const ImageWrapper = styled.div`
  width: 6rem;
  height: 6rem;

  img {
    width: 6rem;
    height: 6rem;
    object-fit: cover;
  }
`

ImageWrapper.displayName = 'ImageWrapper'

export const InputWrapper = styled.div<{ theme: ThemeProps }>`
  background-color: ${({ theme }) => (theme === 'light' ? 'var(--white)' : 'transparent')};
  width: 100%;

  @media (min-width: 1200px) {
    width: 33.5rem;
  }
`

InputWrapper.displayName = 'InputWrapper'
